package com.nonopn.skywatcher.common.login.pages

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.nonopn.skywatcher.common.login.LocalLoginCaller
import com.nonopn.skywatcher.common.login.LocalLoginTitle
import com.nonopn.skywatcher.common.login.sub.LogInAccountScreen
import eu.codlab.compose.widgets.systemBackground
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteLogin : RouteParameterTo

object RouterLogin : RouterNoParameters<RouteLogin>(RouteLogin::class) {
    override fun routeFrom(parameters: RouteLogin) = "/login"

    @Composable
    override fun Show(parameters: RouteLogin) {
        RouteLoginImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteLogin,
        stack = NavigateToStack(
            popBackStack = false,
            options = NavigateWithNavOptions(
                launchSingleTop = false,
                popUpBackTo = RouteMain
            )
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteLogin

    override fun isMatching(route: String) = route == "/login"

    override fun navigateFrom(path: String) = RouteLogin
}

class RouteLoginImpl : Route<RouteLogin>(
    route = "/login",
    params = RouteLogin,
) {
    @Composable
    override fun scene() {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .systemBackground()
        ) {
            LogInAccountScreen(
                loginCaller = LocalLoginCaller.current,
                loginTitle = LocalLoginTitle.current
            )
        }
    }
}
